// FEAT-035 (B1): PMCF activate 지정은 Product 의 전용 타입 필드 isPmcfDevice(boolean)에 저장.
// 쓰기는 $set.isPmcfDevice 로만 유입(BE sanitizer setAllowedKeys 허용). 조회 필터/리스트 컬럼도 동일 필드.
export const PMCF_FIELD = 'isPmcfDevice';
export const pmcfDesignatePayload = (on) => ({ $set: { [PMCF_FIELD]: Boolean(on) } });
export const pmcfFilterMatch = () => ({ [PMCF_FIELD]: true });
